import { useState, useEffect, useCallback } from 'react';
import { useLanguageStore } from '../store/languageStore';
import { translate, loadLocaleIfNeeded, TranslationKey } from '../i18n/translations';

export function useTranslation() {
  const language = useLanguageStore((state) => state.language);
  const [localeReadyTick, setLocaleReadyTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    void loadLocaleIfNeeded(language).then(() => {
      if (!cancelled) setLocaleReadyTick((n) => n + 1);
    });
    return () => {
      cancelled = true;
    };
  }, [language]);

  const t = useCallback(
    (key: TranslationKey, params?: Record<string, string | number>) => {
      return translate(key, language, params);
    },
    [language, localeReadyTick],
  );

  return { t, language };
}

